import React from 'react';
import { Typography } from '@mui/material';
import { useFirmInfoHeaderStyles } from './styles';
import { FirmInfoHeaderProps } from './types';

const FirmInfoHeader = ({ taskData }: FirmInfoHeaderProps) => {
  const classes = useFirmInfoHeaderStyles();
  const { company_name: companyName } = taskData;

  return (
    <div className={classes.container}>
      <div>
        <Typography className={classes.companyName}>{companyName}</Typography>
      </div>
      <div>
        <Typography className={classes.infoText}>Please upload the information required by our analysts.</Typography>
      </div>
    </div>
  );
};
export default FirmInfoHeader;
